import { Typography } from "@mui/material";
import React from "react";
import { StyledDivider } from "../../../status-header/PortalHeaderStyles";
import { useHeaderTextContent } from "./HeaderTextContent.hook";

const HeaderTextContent = ({ isReadOnly }) => {
  const { mainText } = useHeaderTextContent(isReadOnly);

  return (
    <>
      <Typography variant="subtitle2" data-testid="header-text-content-main">{mainText}</Typography>
      {isReadOnly ? <>
        <StyledDivider isReadOnly={isReadOnly} orientation="vertical" />
        <Typography variant="subtitle2" data-testid="header-text-content-read-only">Read only mode</Typography>
      </> : null}
    </>
  );
};

export default HeaderTextContent;
